import React from 'react';
import {useTranslation} from 'react-i18next';
import {Chip} from '@ezcater/tapas';
import {orderSourcesEnum} from '../graphql/enums';

function useOrderSourceLabel(orderSourceType) {
  const {t} = useTranslation();
  switch (orderSourceType) {
    case orderSourcesEnum.MARKETPLACE:
      return t('orderSources.MARKETPLACE');
    case orderSourcesEnum.EZ_ORDERING:
      return t('orderSources.EZ_ORDERING');
    case orderSourcesEnum.DIRECT_ENTRY:
      return t('orderSources.DIRECT_ENTRY');
    case orderSourcesEnum.CLUB_SODA:
      return t('orderSources.CLUB_SODA');
    default:
      return null;
  }
}

export const OrderSourceTypeBadge = ({orderSourceType}) => {
  const badgeText = useOrderSourceLabel(orderSourceType);
  return badgeText ? <Chip>{badgeText}</Chip> : null;
};

export default OrderSourceTypeBadge;
